import { createStore } from 'vuex';
export default createStore({
    state: {
        user: null,
        products: [],
        orders: [],
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setProducts(state, products) {
            state.products = products;
        },
        addOrder(state, order) {
            state.orders.push(order);
        },
    },
    actions: {
        fetchProducts({ commit }) {
            // Fetch products from the backend and commit to state
        },
        placeOrder({ commit }, order) {
            // Place order through the backend and commit to state
            commit('addOrder', order);
        },
    },
    getters: {
        isAuthenticated(state) {
            return !!state.user;
        },
        allProducts(state) {
            return state.products;
        },
        userOrders(state) {
            return state.orders;
        },
    },
});
